import { render, staticRenderFns } from "./SectionUpdate.vue?vue&type=template&id=0b47cb8b"
import script from "./SectionUpdate.vue?vue&type=script&lang=js"
export * from "./SectionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports